import {Thumbmark} from '@thumbmarkjs/thumbmarkjs';
import Vue from "vue";

export async function getVisitorFingerprint(apiKey: string | undefined = undefined) {
    const thumbmark = new Thumbmark({
        api_key: apiKey, // optional for higher accuracy
        stabilize: ['private'], // improve consistency in incognito mode
    });

    return await thumbmark.get();
}

export async function ThumbmarkPlugin(vue: typeof Vue, options?: any): Promise<void> {
    vue.prototype.$thumbmark = await getVisitorFingerprint()
}